import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <div className="bg-gradient-to-b from-[#C0392B]/10 to-[#0D0D0D] py-6 px-5 border-t-2 border-[#F1C40F]" data-id="element-33">
      <div className="max-w-3xl mx-auto text-center" data-id="element-34">
        <p className="text-[#F1C40F] text-xs font-bold tracking-wider uppercase mb-2" data-id="element-35">
          ⏰ Precio de lanzamiento por tiempo limitado
        </p>

        <h2 className="font-serif text-xl sm:text-2xl text-[#C0392B] mb-2 uppercase tracking-wider" data-id="element-36">
          Tu Pizza Perfecta te Espera
        </h2>

        <p className="text-sm text-[#CCCCCC] max-w-xl mx-auto mb-4 leading-relaxed" data-id="element-37">
          Seguir haciendo pizzas mediocres, o invertir hoy en el sistema que
          transformará tu cocina en una pizzería de clase mundial.
        </p>

        <motion.a href="#precio" className="inline-block bg-gradient-to-br from-[#C0392B] to-[#922B21] text-[#F1C40F] px-8 py-3 rounded-md text-base font-bold uppercase tracking-wider border-2 border-[#F1C40F] cursor-pointer" whileHover={{
        y: -3,
        scale: 1.02
      }} animate={{
        boxShadow: ['0 8px 30px rgba(192,57,43,0.5)', '0 8px 50px rgba(192,57,43,0.9)', '0 8px 30px rgba(192,57,43,0.5)']
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-38">
          🍕 QUIERO SER UN MAESTRO PIZZERO
        </motion.a>
        <span className="block text-[10px] text-[#F5F5F5] mt-1.5 opacity-80" data-id="element-39">
          ✅ 2 Tomos · ✅ 50 Recetas · ✅ 5 Bonos · ✅ Garantía Total
        </span>

        <div className="mt-4 flex flex-wrap justify-center gap-4 text-[#444] text-[10px]" data-id="element-40">
          <span data-id="element-41">🔒 Pago Seguro</span>
          <span data-id="element-42">📲 Acceso Inmediato</span>
          <span data-id="element-43">🛡️ Garantía Incluida</span>
        </div>
      </div>
    </div>;
}